import React from 'react';
import CV from '../../assets/KretsulVitalii_v10.pdf';

const CTA = ({ setActiveNav }) => {
  return (
    <div className="cta">
      <a href={CV} download className="btn">
        Download CV
      </a>
      <a
        href="#contact"
        className="btn btn-primary"
        onClick={() => setActiveNav('#contact')}
      >
        Let's talk
      </a>
    </div>
  );
};

export default CTA;
